/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_SectionInputs */

const en_highlight_settings_section = /** @type {(inputs: Highlight_Settings_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Section`)
};

const es_highlight_settings_section = /** @type {(inputs: Highlight_Settings_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sección`)
};

/**
* | output |
* | --- |
* | "Section" |
*
* @param {Highlight_Settings_SectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_section = /** @type {((inputs?: Highlight_Settings_SectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_SectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_section(inputs)
	return en_highlight_settings_section(inputs)
});